
export default class GECStore {
    static _controller: any;

    static getController() {
        return GECStore._controller;
    }

    static setController(controller:any) {
        GECStore._controller = controller;
    }

}